// External
import _ from "lodash";
import PropTypes from "prop-types";
import React, { memo } from "react";

// Relative Components
import { BulkDownload, SingleDownload } from "./components";

const DownloadTranscriptsModal = ({
  onClose,
  studentIds,
  schoolIds,
  templates,
  studentIdToSchoolIdMap,
  selectedTemplate,
  studentName,
  resetSelection,
  testId,
}) => {
  if (_.size(studentIds) === 1)
    return (
      <SingleDownload
        studentId={_.first(studentIds)}
        schoolId={_.first(schoolIds)}
        onClose={onClose}
        selectedTemplate={selectedTemplate}
        studentName={studentName}
        resetSelection={resetSelection}
        testId={testId}
      />
    );

  return (
    <BulkDownload
      studentIds={studentIds}
      schoolIds={schoolIds}
      templates={templates}
      onClose={onClose}
      studentIdToSchoolIdMap={studentIdToSchoolIdMap}
      resetSelection={resetSelection}
      testId={testId}
    />
  );
};

DownloadTranscriptsModal.propTypes = {
  onClose: PropTypes.func.isRequired,
  studentIds: PropTypes.arrayOf(PropTypes.string),
  schoolIds: PropTypes.arrayOf(PropTypes.string),
  templates: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string,
      name: PropTypes.string,
    })
  ),
  studentIdToSchoolIdMap: PropTypes.objectOf(PropTypes.string),
  selectedTemplate: PropTypes.shape({
    value: PropTypes.string,
    label: PropTypes.string,
  }),
  studentName: PropTypes.string,
  resetSelection: PropTypes.func,
  testId: PropTypes.string,
};

DownloadTranscriptsModal.defaultProps = {
  studentIds: [],
  schoolIds: [],
  templates: [],
  studentIdToSchoolIdMap: {},
  selectedTemplate: null,
  studentName: "",
  resetSelection: null,
  testId: "",
};

export default memo(DownloadTranscriptsModal);
